var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140.591 140.591",
    style: {
      enableBackground: "new 0 0 140.591 140.591"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.091,140.591H2.5c-1.381,0-2.5-1.119-2.5-2.5V2.5C0,1.119,1.119,0,2.5,0h135.591 c1.381,0,2.5,1.119,2.5,2.5v135.591C140.591,139.472,139.472,140.591,138.091,140.591z M105.118,135.591h30.473v-30.473 l-28.266,28.266c-0.004,0.004-0.008,0.009-0.013,0.013c-0.004,0.004-0.009,0.009-0.013,0.013L105.118,135.591z M66.202,135.591 h31.846l3.962-3.962l-15.923-15.923L66.202,135.591z M29.869,135.591h29.262l43.462-43.462L87.962,77.498l-46.149,46.149l0,0 L29.869,135.591z M5,135.591h17.798l13.712-13.712l-15.362-15.362L5,122.665V135.591z M89.622,112.17l15.923,15.923l30.046-30.046 V66.202l-27.695,27.695l0,0L89.622,112.17z M24.684,102.981l15.361,15.362l76.673-76.673l-15.362-15.362L71.297,56.368 c-0.003,0.002-0.005,0.004-0.007,0.006L24.684,102.981z M5,82.009v33.584l14.354-14.355c0.009-0.008,0.017-0.017,0.025-0.025 c0.008-0.009,0.017-0.017,0.025-0.025l46.582-46.583L49.545,38.164L5,82.009z M91.497,73.962l14.631,14.631l29.39-29.389 c0.024-0.024,0.049-0.048,0.073-0.071V29.868L91.497,73.962z M5,41.208v33.785l19.798-19.487L7.833,38.54L5,41.208z M11.474,35.11 l16.888,16.888l47.58-46.832H43.265L11.474,35.11z M53.108,34.656L69.522,51.07L115.593,5H83.238L53.108,34.656z M104.891,22.773 l15.362,15.362l15.338-15.338V5h-12.927L104.891,22.773z M5,5v29.34l0.935-0.88c0.053-0.064,0.108-0.125,0.168-0.185 c0.096-0.096,0.198-0.183,0.305-0.26L36.148,5H5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloor);
export default __webpack_public_path__ + "static/media/icon-floor.3e0f3f59ce9c839ad28b665e08593ba3.svg";
export { ForwardRef as ReactComponent };